import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


const routes: Routes = [
   { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: ':club-url', redirectTo: 'pages/club/:club-url' },
  // { path: 'accounts', loadChildren: './accounts/accounts.module#AccountsModule' },
  { path: 'pages', loadChildren: './pages/pages.module#PagesModule' },
  { path: 'widgets', loadChildren: './widgets/widgets.module#WidgetsModule' },
  { path: '**', redirectTo: 'pages', pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      scrollPositionRestoration: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
